import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicFeaturesGrid3 from '../../RifoDesign/EpicFeaturesGrid3/epic.features.grid3.vue';
import EpicGraphicTextSection from '../../RifoDesign/EpicGraphicTextSection/epic.graphic.text.section.vue';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        'layout': EpicStandardLayout,
        EpicHeaderBannerText,
        EpicFeaturesGrid3,
        EpicGraphicTextSection
    }
})
export default class EpicResearchSuburb extends Vue {
    public data: string = '';
    public configs = new CommonConfig();
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg0.jpg`;
    public featureGridList = [{
        img: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/round-1.png`,
        tagline: 'EXPLORE THE COMMUNITY',
        description: ''
    }, {
        img: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/round-2.png`,
        tagline: 'KNOW AGES NEARBY',
        description: ''
    }, {
        img: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/round-3.png`,
        tagline: 'JOBS AND INCOME',
        description: ''
    }];

    public sections = [{
        reverse: false,
        graphic: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/graphic1.png`,
        title: 'Explore The Community',
        bgColor: '#ECF8FA',
        stepList: [{
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/icon1.png`,
            title: 'Neighbourhood & Community',
            paragraph: 'Detailed information about neigbourhood to evaluate your community environment.'
        }, {
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/icon2.png`,
            title: 'School Ranking',
            paragraph: 'Providing latest report on each school‘s academic ranking around any property.'
        }]
    }, {
        reverse: true,
        title: 'Know Ages Nearby',
        graphic: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/graphic2.png`,
        bgColor: '#FFFFFF',
        stepList: [{
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/icon3.png`,
            title: 'Construction Year',
            paragraph: 'Exploring the house ages  scale in community to analyze your property value.'
        }, {
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/icon4.png`,
            title: 'Age Distribution',
            paragraph: 'Showing the distribution of various age group to help you feel compatible to fit in.'
        }]
    }, {
        reverse: false,
        title: 'Jobs and Income',
        graphic: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/graphic3.png`,
        bgColor: '#ECF8FA',
        stepList: [{
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/icon5.png`,
            title: 'Employment Type',
            paragraph: 'Finding what kind of jobs people are doing around the property in your living environment.  '
        }, {
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-research-suburb/icon6.png`,
            title: 'General Household Income',
            paragraph: 'Learning average income that family can earn in your community for future oppotunity. '
        }]
    }];

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public created() {
    }

    public mounted() {
    }
}
